var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVegetables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_690_5057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4292 10.3918C18.2445 10.1982 18.1126 10.0455 18.0409 9.95972C17.9551 9.88806 17.8024 9.75617 17.6088 9.57147C16.7428 8.88631 15.6796 8.51331 14.5586 8.51331C13.2421 8.51331 12.0044 9.02602 11.0735 9.95688C8.563 12.4675 5.71012 16.7055 2.8234 22.2129C1.62241 24.5042 0.643502 26.5818 0.000534058 28C1.41875 27.357 3.49633 26.3781 5.78762 25.1771C11.295 22.2904 15.5331 19.4376 18.0437 16.927C18.9746 15.9961 19.4873 14.7584 19.4873 13.4419C19.4873 12.3209 19.1143 11.2578 18.4292 10.3918Z",
    fill: "#84A756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9994 9.3771C27.4974 8.86991 26.6285 8.10292 25.5825 7.63972C25.4104 7.88455 25.2163 8.11882 24.9975 8.33768C23.7452 9.58994 21.9903 10.0337 20.6235 10.1753C21.4666 10.8404 22.6235 11.5095 23.8656 11.5095C25.6389 11.5094 27.2387 10.1456 27.9994 9.3771Z",
    fill: "#84A756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4912 4.13493C16.4912 5.39791 17.1999 6.57403 17.7945 7.33824C17.8047 7.35141 17.8149 7.36426 17.8252 7.37726C17.9667 6.01049 18.4107 4.2554 19.663 3.00308C19.882 2.78412 20.1163 2.59002 20.3613 2.41778C19.8973 1.36683 19.1315 0.500195 18.6246 0C17.8567 0.759722 16.4912 2.3605 16.4912 4.13493Z",
    fill: "#84A756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8225 4.16262C19.5686 5.41647 19.4017 7.51197 19.4073 8.59337C19.424 8.59343 19.4409 8.59348 19.4581 8.59348C20.5532 8.59348 22.6034 8.41261 23.8379 7.17811C25.0919 5.92426 25.2587 3.8287 25.2532 2.7473C25.2364 2.74725 25.2195 2.74719 25.2023 2.74719C24.1079 2.74725 22.0572 2.9279 20.8225 4.16262Z",
    fill: "#84A756"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_690_5057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegetables);
export default __webpack_public_path__ + "static/media/vegetables.b2c3dd218c251004ad5ef1d90123718c.svg";
export { ForwardRef as ReactComponent };